import styled, { CSSObject } from 'styled-components';
import { ButtonProps, Button as MuiButton } from '@material-ui/core';

const ButtonStylesMap: Record<NonNullable<ButtonProps['size']>, CSSObject> = {
  large: {
    fontSize: '1.05rem',
  },
  medium: {
    fontSize: '1rem',
  },
  small: {
    fontSize: '0.85rem',
  },
};

export const Button = styled(MuiButton)`
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ size }) => ButtonStylesMap[size!]}
`;
